import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";

import { CircleX, MailX, Plus } from "lucide-react";

import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "../../components/ui/card";
import { Button } from "../../components/ui/button";

import CreateInviteModal from "../../components/CreateInviteModal";

import useProject from "../../components/hooks/useProject";

import { where } from "firebase/firestore";
import firestoreService from "../../services/firestoreService";

export default function ProjectInvites() {
  const { projectId } = useParams();
  const { project } = useProject(projectId);

  const [projectInvites, setProjectInvites] = useState([]);
  const [inviteModalOpen, setInviteModalOpen] = useState(false);

  useEffect(() => {
    if (project) {
      const unsubscribe = firestoreService.subscribeToCollection(
        `projects/${project.id}/invites`,
        [where("status", "==", "pending")],
        setProjectInvites
      );

      // Cleanup the listener on component unmount
      return () => unsubscribe();
    }
  }, [project]);

  const handleInviteMember = () => {
    setTimeout(() => {
      setInviteModalOpen(true);
    }, 200);
  };

  return (
    <>
      {project && (
        <Card>
          <div className="flex items-center justify-between space-x-4">
            <CardHeader>
              <CardTitle>Invites</CardTitle>

              <CardDescription>
                Invite members to collaborate on your project.
              </CardDescription>
            </CardHeader>

            <CreateInviteModal
              open={inviteModalOpen}
              setOpen={setInviteModalOpen}
              inviteType={"project"}
              projectId={project.id}
            />

            <div className="flex flex-col pr-4">
              <Button className="max-w-[150px]" onClick={handleInviteMember}>
                <Plus size={16} className="mr-2" />
                Invite Member
              </Button>
            </div>
          </div>

          <CardContent className="flex flex-col gap-6 max-h-[228px] min-h-[228px] overflow-y-auto">
            {projectInvites.length > 0 ? (
              projectInvites.map((invite, index) => (
                <div
                  key={index}
                  className="flex items-center justify-between space-x-4"
                >
                  <div className="flex items-center space-x-4">
                    <div>
                      <p className="text-md font-medium leading-none capitalize">
                        {invite.projectRole}
                      </p>

                      <p className="text-sm text-muted-foreground mt-1">
                        {invite.email}
                      </p>
                    </div>
                  </div>

                  <Button variant="outline" className="max-w-[150px]">
                    <CircleX size={16} className="mr-2" />
                    Cancel
                  </Button>
                </div>
              ))
            ) : (
              <div className="flex items-center justify-center text-sm font-semibold space-x-2 mt-6">
                <MailX className="w-5 h-5" />
                <span>No pending invites</span>
              </div>
            )}
          </CardContent>
        </Card>
      )}
    </>
  );
}
